function addImageDimensions(url, width, defaultImageUrl) {
  if (!url || url.lastIndexOf('.') === -1) return defaultImageUrl;
  const lastDotIndex = url.lastIndexOf('.');
  return `${url.substring(0, lastDotIndex)}_${width}x${url.substring(lastDotIndex)}`;
}
// Product card images: Shopify CDN resizes by query parameter.
function addImageWidth(url, width, defaultImageUrl) {
  if (!url) return defaultImageUrl;
  return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + width;
}
// Promo badges - keep in sync with snippets/promo-badges.liquid and assets/boost-pfs-filter.js.
// Relies on the app's html tag escaping interpolated strings.
function algoliaPromoBadges(html, tags) {
  const has = (t) => tags.includes(t);
  const truck = html`<svg aria-hidden="true" focusable="false" viewBox="0 0 24 24" width="12" height="12" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M1 3h15v13H1z"/><path d="M16 8h4l3 3v5h-7z"/><circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/></svg>`;
  const gift = html`<svg aria-hidden="true" focusable="false" viewBox="0 0 24 24" width="12" height="12" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 12v10H4V12"/><path d="M2 7h20v5H2z"/><path d="M12 22V7"/><path d="M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7z"/><path d="M12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z"/></svg>`;
  const ship = has('free-canada') ? ['Free shipping · Canada', 'Ships free across Canada']
    : has('free-shipping-50') ? ['Free shipping · 50 km', "Ships free within 50 km of Canada's major cities"]
    : has('free-shipping') ? ['Free shipping', 'Ships free']
    : has('free-local') ? ['Free local', 'Free local delivery']
    : null;
  const freeGift = has('free-gift');
  if (!ship && !freeGift) return '';
  return html`<div class="promo-badges">${ship ? html`<span class="promotionItems promotionItems--shipping" title=${ship[1]}>${truck}<span class="visually-hidden">${ship[1]}</span><span aria-hidden="true">${ship[0]}</span></span>` : ''}${freeGift ? html`<span class="promotionItems promotionItems--gift" title="Includes a free gift">${gift}<span class="visually-hidden">Includes a free gift</span></span>` : ''}</div>`;
}
// Review stars drawn from the hit's Judge.me data. Five grey stars with a gold
// copy on top, clipped to the rating. No reviews returns '' so the card renders
// nothing between title and price, like the collection card's Judge.me badge.
const STAR_PATH = 'M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01z';
function algoliaStars(html, data) {
  const reviews = data.meta && data.meta.reviews;
  const rating = reviews ? Number(reviews.rating) : 0;
  const count = reviews ? Number(reviews.rating_count) : 0;
  if (!(count > 0) || !Number.isFinite(rating)) return '';
  const pct = Math.max(0, Math.min(100, (rating / 5) * 100));
  const five = () => [0, 1, 2, 3, 4].map(() => html`<svg aria-hidden="true" focusable="false" viewBox="0 0 24 24" width="15" height="15"><path d=${STAR_PATH}/></svg>`);
  return html`<div class="search-stars" role="img" aria-label=${`${rating} out of 5 stars, ${count} reviews`}>
    <span class="search-stars__track">${five()}<span class="search-stars__fill" style=${`width:${pct}%`}>${five()}</span></span>
    <span class="search-stars__count" aria-hidden="true">(${count})</span>
  </div>`;
}
const DEFAULT_IMAGE_URL ='https://www.nellaonline.com/cdn/shop/t/229/assets/boost-pfs-no-image_200x.gif?v=45510820439899768411709822951';

document.addEventListener('algolia.hooks.initialize', function() {
  algoliaShopify.hooks.registerHook('afterISStartRemoveDefaultWidget', function(defaultWidgets) {

    // const searchBoxWidget = defaultWidgets.find(
    //   widget => widget.$$widgetType === 'ais.searchBox'
    // );

    const paginationWidget = defaultWidgets.find(
      widget => widget.$$widgetType === 'ais.pagination'
    )
    return [paginationWidget];
  });
});


document.addEventListener('algolia.hooks.initialize', function () {
  const { widgets } = window.instantsearch;

  // const createQueryWidget = instantsearch.connectors.connectSearchBox(
  //   (renderOptions, isFirstRender) => {
  //     const { query, widgetParams } = renderOptions;

  //     if (isFirstRender) {
  //       widgetParams.container.innerHTML = '<div id="query-display"></div>';
  //     }

  //     const queryDisplayElement = widgetParams.container.querySelector('#query-display');
  //     queryDisplayElement.textContent = `Search results for: "${query}"`;
  //   }
  // );


  algoliaShopify.hooks.registerHook('beforeISStartAddWidgetArray', function () {

    const collectionIndex = widgets
      .index({
        indexName:
          'shopify_collections',
      })
      .addWidgets([
        widgets.hits({
          cssClasses: {
            root: 'collectionResults',
            list: ['collectionResultsList'],
          },
          container: '#collectionsearchResults',
          templates: {
            item: (hit) => {
              const modifiedImageUrl = addImageDimensions(hit.image, 95, DEFAULT_IMAGE_URL);
              return `
              <a href="/collections/${hit.handle}" style="display:flex;align-items:center;text-align:left;text-decoration:none;">
              <div style="text-align:center;">
              <img src="${modifiedImageUrl}" height="95" width="95">
              </div>
              <div style="text-decoration:none;">
              <div class="smallcattitle">${hit.title}</div>
              <div style="font-style:italic;font-size:0.75rem;line-height:2;text-decoration:none;color:#1d1d1d;margin-left:10px;">
              ${hit.products_count} PRODUCTS
              </div>
              </div>
              </a>
             `;
            },
            empty: '',
          },
        }),
        widgets.configure({
          hitsPerPage: 16,
        }),
        widgets.pagination({
          container:'#nonexistent',
          totalPages: 1,
          showFirst: false,
          scrollTo: false,
        }),
      ]);

      const customPaginationWidget = instantsearch.widgets.pagination({
        container: '#resultsPagination',
        scrollTo: '.viewContainer',
        showFirst: true,
        showLast: true,
      });

    return [collectionIndex,customPaginationWidget];

  });
});

// Search click tracking: the template is a string, so clicks are caught by one
// delegated listener that looks up the card's hit and reports it to Algolia.
const algoliaHitsByObjectId = new Map();
let algoliaTrackSearchAttribution = null;
let algoliaClickListenerAdded = false;

function addAlgoliaClickListener() {
  if (algoliaClickListenerAdded) return;
  algoliaClickListenerAdded = true;
  document.addEventListener('click', function (event) {
    const target = event.target;
    if (!target || typeof target.closest !== 'function') return;
    const card = target.closest('.searchItems');
    if (!card) return;
    if (!target.closest('a[href]') && !target.closest('.productitem--action-atc')) return;
    const hit = algoliaHitsByObjectId.get(card.getAttribute('data-algolia-objectid'));
    if (hit && typeof algoliaTrackSearchAttribution === 'function') {
      try {
        algoliaTrackSearchAttribution(hit);
      } catch (e) {
        // Tracking must never block navigation or add to cart.
      }
    }
    const atcButton = target.closest('.productitem--action-atc[data-variant-id]');
    if (atcButton) algoliaAddToCart(event, atcButton);
  });
}

// Add to cart: same form data and options as a collection card's quick buy
// (Empire's ProductGridItem._addToCart), opening the theme's cart banner.
// AddToCartFlyout is exposed on window.Theme by assets/empire.js.liquid.
// The banner formats prices with Shopify.formatMoney, which nothing on the
// search page defines (shopify_common.js doesn't have it). So when it's missing,
// define Shopify's standard formatter, defaulting to the shop's money format
// from data-money-format on .topresultsContainer in layout/theme.liquid.
let algoliaAddToCartFlyout = null;

function algoliaEnsureFormatMoney() {
  if (window.Shopify && typeof window.Shopify.formatMoney === 'function') return;
  window.Shopify = window.Shopify || {};
  window.Shopify.formatMoney = function (cents, format) {
    const container = document.querySelector('.topresultsContainer');
    const formatString = format || (container && container.dataset.moneyFormat) || '${{amount}}';
    const value = typeof cents === 'string' ? cents.replace('.', '') : cents;
    const delimit = function (number, precision, thousands, decimal) {
      const amount = Number(number);
      if (!Number.isFinite(amount)) return '0';
      const parts = (amount / 100).toFixed(precision).split('.');
      const dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, `$1${thousands}`);
      return parts[1] ? dollars + decimal + parts[1] : dollars;
    };
    const match = formatString.match(/\{\{\s*(\w+)\s*\}\}/);
    if (!match) return formatString;
    let formatted;
    switch (match[1]) {
      case 'amount_no_decimals': formatted = delimit(value, 0, ',', '.'); break;
      case 'amount_with_comma_separator': formatted = delimit(value, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': formatted = delimit(value, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': formatted = delimit(value, 2, "'", '.'); break;
      case 'amount_no_decimals_with_space_separator': formatted = delimit(value, 0, ' ', ''); break;
      case 'amount_with_space_separator': formatted = delimit(value, 2, ' ', ','); break;
      case 'amount_with_period_and_space_separator': formatted = delimit(value, 2, ' ', '.'); break;
      default: formatted = delimit(value, 2, ',', '.');
    }
    return formatString.replace(/\{\{\s*(\w+)\s*\}\}/, formatted);
  };
}

function algoliaResetAtcButton(atcButton) {
  atcButton.classList.remove('processing');
  atcButton.removeAttribute('disabled');
}

// Fallback so the button never does nothing: add, then go to the cart. On a failed
// add (sold out, too many), log Shopify's message and give the button back.
function algoliaAddToCartFallback(formData, atcButton) {
  const routes = (window.Theme && window.Theme.routes) || {};
  const cartUrl = routes.cart_url || '/cart';
  const addUrl = (routes.cart_add_url || '/cart/add') + '.js';
  const body = new FormData();
  formData.forEach(function (field) { body.append(field.name, field.value); });
  atcButton.classList.add('processing');
  atcButton.setAttribute('disabled', '');
  fetch(addUrl, { method: 'POST', body: body, headers: { Accept: 'application/json' } })
    .then(function (response) {
      if (response.ok) {
        window.location.href = cartUrl;
        return;
      }
      return response.json()
        .catch(function () { return {}; })
        .then(function (data) {
          console.error('Search Add to cart failed.', (data && data.description) || response.status);
          algoliaResetAtcButton(atcButton);
        });
    })
    .catch(function (error) {
      console.error('Search Add to cart failed.', error);
      algoliaResetAtcButton(atcButton);
    });
}

function algoliaOpenFlyout(Flyout, formData, atcButton) {
  if (algoliaAddToCartFlyout) algoliaAddToCartFlyout.unload();
  const container = document.querySelector('.topresultsContainer');
  const moneyFormat = (container && container.dataset.moneyFormat) || null;
  algoliaAddToCartFlyout = new Flyout(formData, {
    atcButton: atcButton,
    settings: { moneyFormat: moneyFormat, cartRedirection: false },
  });
}

function algoliaAddToCart(event, atcButton) {
  event.preventDefault();
  if (atcButton.classList.contains('processing')) return;
  const variantId = atcButton.getAttribute('data-variant-id');
  const formData = [
    { name: 'id', value: variantId },
    { name: 'quantity', value: 1 },
    { name: 'properties[AcceptSubstitutions]', value: 'No' },
  ];
  const Flyout = window.Theme && window.Theme.AddToCartFlyout;
  if (typeof Flyout !== 'function') {
    algoliaAddToCartFallback(formData, atcButton);
    return;
  }
  // The try/catch covers synchronous failures opening the banner. The watchdog covers
  // the rest: if the banner's request never settles, the button comes back after 8s.
  try {
    algoliaEnsureFormatMoney();
    algoliaOpenFlyout(Flyout, formData, atcButton);
    clearTimeout(atcButton.algoliaWatchdog);
    atcButton.algoliaWatchdog = setTimeout(function () {
      if (atcButton.classList.contains('processing')) algoliaResetAtcButton(atcButton);
    }, 8000);
  } catch (error) {
    console.error('Search Add to cart: the cart banner failed to open.', error);
    algoliaAddToCartFallback(formData, atcButton);
  }
}

// Desktop hover: on collection cards Empire grows the card down by the height of its
// button row. The search block CSS in layout/theme.liquid does the same, reading the
// row's height from --search-actions-height, which this sets as the pointer or focus enters.
let algoliaHoverListenerAdded = false;

function addAlgoliaHoverListener() {
  if (algoliaHoverListenerAdded) return;
  algoliaHoverListenerAdded = true;
  const setActionsHeight = function (event) {
    const target = event.target;
    if (!target || typeof target.closest !== 'function') return;
    const card = target.closest('.searchItems');
    if (!card) return;
    const actions = card.querySelector('.productitem--actions');
    if (!actions) return;
    card.style.setProperty('--search-actions-height', `${actions.getBoundingClientRect().height}px`);
  };
  document.addEventListener('mouseover', setActionsHeight);
  document.addEventListener('focusin', setActionsHeight);
}

document.addEventListener('algolia.hooks.initialize', function () {

  // Zero-results state: query, category links from the header menu, contact link.
  // Data comes from the .topresultsContainer data attributes in layout/theme.liquid.
  algoliaShopify.hooks.registerHook('beforeInstantSearchNoResultTemplate', function (_defaultTemplate, html) {
    const container = document.querySelector('.topresultsContainer');
    let categories = [];
    try {
      const parsed = JSON.parse((container && container.dataset.searchCategories) || '[]');
      if (Array.isArray(parsed)) categories = parsed;
    } catch (e) {
      categories = [];
    }
    const contactUrl = (container && container.dataset.searchContactUrl) || '/pages/contact-us';
    const query = new URLSearchParams(location.search).get('q') || '';
    const title = query ? `No results for "${query}"` : 'No results';

    return html`
      <div class="search-empty">
        <h2 class="search-empty__title">${title}</h2>
        <p class="search-empty__hint">Check the spelling, or try a shorter word.</p>
        ${categories.length ? html`
          <p class="search-empty__label">Shop by category</p>
          <ul class="search-empty__cats">
            ${categories.map((cat) => html`<li><a href=${cat.url}>${cat.title}</a></li>`)}
          </ul>
        ` : ''}
        <p class="search-empty__contact">Can't find it? <a href=${contactUrl}>Email us</a> and we'll track it down.</p>
      </div>
    `;
  });

  // Card markup mirrors the collection card (snippets/boost-pfs-filter-html.liquid,
  // productGridItemHtml) so theme.css styles it. Keep the two in sync.
  algoliaShopify.hooks.registerHook('beforeInstantSearchProductTemplate', function (defaultTemplate, data, html, components, trackSearchAttribution) {
    if (typeof trackSearchAttribution === 'function') algoliaTrackSearchAttribution = trackSearchAttribution;
    algoliaHitsByObjectId.set(String(data.objectID), data);
    addAlgoliaClickListener();
    addAlgoliaHoverListener();
    const algoliaPosition = data.productPosition !== undefined ? data.productPosition
      : data.__position !== undefined ? data.__position
      : '';

    const tags = Array.isArray(data.tags) ? data.tags : [];
    const hidePrice = tags.includes('hideprice');
    const noPrice = tags.includes('emailprice') || tags.includes('discontinued');

    const imageUrl = addImageWidth(data.image, 512, DEFAULT_IMAGE_URL);
    const productUrl = `/products/${data.handle}`;

    const formatPrice = (value) => new Intl.NumberFormat('en-US', {
      style: 'decimal',
      minimumFractionDigits: 2
    }).format(value);

    // Owner decision 2026-11-03: a card never shows a sale price the product page
    // won't honour. Show this record's own price, or "From" the lowest variant price
    // with no strike-through. Use this record's own compare_at_price, not
    // variants_compare_at_price_min: a missing compare price is indexed as 0.
    const price = Number(data.price);
    const minPrice = Number(data.variants_min_price);
    const compare = Number(data.compare_at_price);
    const showFrom = Number.isFinite(minPrice) && minPrice < price;
    const hasCompare = !showFrom && Number.isFinite(compare) && compare > price;
    // Sale badge style is "text" in settings_data.json, so the badge says "Sale"
    // as on collection cards. Hidden-price products get no badge, as on collections.
    const showSaleBadge = hasCompare && !hidePrice && !noPrice;

    const title = components && typeof components.Highlight === 'function'
      ? components.Highlight({ attribute: 'title', hit: data })
      : data.title;

    const stars = algoliaStars(html, data);

    // Price markup from assets/boost-pfs-filter.js (collection card).
    const priceBlock = hidePrice
      ? html`
        <div style="display:flex;margin:15px 0px;align-items:center;">
          <div class="specialhiddenprice"><div style="font-size:var(--font-size-body-smallest);">Special Price</div>$?,???</div>
          ${hasCompare ? html`
            <div>
              <div style="font-size:var(--font-size-body-smallest);">Reg.</div>
              <div style="font-size:var(--font-size-body-small);text-decoration: line-through;color:#5a5a5a;">$${formatPrice(compare)}</div>
            </div>` : ''}
        </div>
        <div style="font-size:var(--font-size-body-small);margin-top:auto;">${data.variants_count > 1 ? 'View product to see price' : 'Add to cart to see price'}</div>`
      : noPrice ? ''
      : html`
        <div class=${`price productitem__price${showFrom ? ' price--varies' : ''}`} style="margin:15px 0px 2px;">
          <div class=${`price__current${hasCompare ? ' price__current--on-sale' : ''}`} data-price-container>
            ${hasCompare ? html`<span class="visually-hidden">Current price</span>` : ''}
            <span class="money" style="font-size:var(--font-size-body-larger);font-weight:600;" data-price>${showFrom ? `From $${formatPrice(minPrice)}` : `$${formatPrice(price)}`}</span>
          </div>
          ${hasCompare ? html`
            <div class="price__compare-at visible" data-price-compare-container>
              <span class="visually-hidden">Original price</span>
              <span class="money price__compare-at--single" data-price-compare>$${formatPrice(compare)}</span>
            </div>` : ''}
        </div>`;

    const canAdd = data.can_order == true && !noPrice && data.variants_count == 1;
    const button = canAdd
      ? html`<button type="button" class="productitem--action-trigger productitem--action-atc button-primary" data-variant-id=${String(data.objectID)}><span class="atc-button--text">Add to cart</span><span class="atc-button--icon"><svg aria-hidden="true" focusable="false" role="presentation" width="26" height="26" viewBox="0 0 26 26" xmlns="http://www.w3.org/2000/svg"><g fill-rule="nonzero" fill="currentColor"><path d="M13 26C5.82 26 0 20.18 0 13S5.82 0 13 0s13 5.82 13 13-5.82 13-13 13zm0-3.852a9.148 9.148 0 1 0 0-18.296 9.148 9.148 0 0 0 0 18.296z" opacity=".29"/><path d="M13 26c7.18 0 13-5.82 13-13a1.926 1.926 0 0 0-3.852 0A9.148 9.148 0 0 1 13 22.148 1.926 1.926 0 0 0 13 26z"/></g></svg></span></button>`
      : noPrice || data.variants_count > 1
        ? html`<a class="productitem--action-trigger productitem--action-atc button-primary search-card__view" href=${productUrl}><span class="atc-button--text">View Product</span></a>`
        : html`<button type="button" class="productitem--action-trigger productitem--action-atc button-primary disabled" disabled><span class="atc-button--text">Sold out</span></button>`;

    return html`
      <div class=${`productitem searchItems imagestyle--medium${hasCompare ? ' productitem--sale' : ''}`}
        data-product-item-content
        data-algolia-index=${String(data.index || '')}
        data-algolia-position=${String(algoliaPosition)}
        data-algolia-queryid=${String(data.queryID || '')}
        data-algolia-objectid=${String(data.objectID)}>
        ${algoliaPromoBadges(html, tags)}
        <a class="productitem--image-link" href=${productUrl} tabindex="-1">
          <figure class="productitem--image">
            <img class="productitem--image-primary" src=${imageUrl} alt=${data.title || ''} loading="lazy" width="512" height="512" />
            ${showSaleBadge ? html`<span class="productitem__badge productitem__badge--sale" data-badge-sales><span data-badge-sales-range>Sale</span></span>` : ''}
          </figure>
        </a>
        <div class="productitem--info">
          <h2 class="productitem--title"><a href=${productUrl}>${title}</a></h2>
          ${stars ? html`<div class="productitem--ratings">${stars}</div>` : ''}
          ${priceBlock}
        </div>
        <div class="productitem--actions"><div class="productitem--action atc--button">${button}</div></div>
      </div>`;
  });
});

document.addEventListener('DOMContentLoaded', function () {
  const container = document.querySelector('#collectionsearchResults');
  const callback = function (mutationsList, observer) {
    for (let mutation of mutationsList) {
      if (mutation.type === 'childList') {
        updateViewMoreButtonVisibility();
      }
    }
  };

  const observer = new MutationObserver(callback);
  observer.observe(container, { childList: true });

  function updateViewMoreButtonVisibility() {
    const allItems = document.querySelectorAll('.collectionResultsList li.ais-Hits-item');
    const totalItemCount = allItems.length;
    const initialVisibleItemCount = 8;
    const viewMoreButton = document.getElementById('viewMoreColl');

    if (totalItemCount > initialVisibleItemCount) {
      viewMoreButton.style.display = 'block';
    } else {
      viewMoreButton.style.display = 'none';
    }
  }
  updateViewMoreButtonVisibility();
});

document.addEventListener('DOMContentLoaded', function () {
  const initialVisibleItemCount = 8; // The number of items you want to show initially

  // Select all items
  const allItems = document.querySelectorAll('.collectionResultsList li.ais-Hits-item');
  const totalItemCount = allItems.length;

  // Select the "View More" link
  const viewMoreButton = document.getElementById('viewMoreColl');

  // Check if there are more items than the initial visible count
  if (totalItemCount > initialVisibleItemCount && viewMoreButton) {
    // If there are hidden items, make the "View More" link visible
    viewMoreButton.style.display = 'block'; // or 'inline', depending on your preference
  }

  // Event listener for the "View More" link, if needed
  viewMoreButton.addEventListener('click', function () {
    // Logic to show hidden items
    // For example, toggle a class on the container that changes the CSS to make hidden items visible
    document.querySelector('.collectionResultsList').classList.toggle('show-more');

    // Hide the "View More" link after it's clicked
    this.style.display = 'none';
  });
});
